import styled from "styled-components/macro";
import { media } from "../../../../utils";

export const BannerIntermediarioStyle = styled.div({
  [media.lg()]: {
    "& > div": { padding: "40px 0" },
  },
});

export default styled.div(({ theme, home }) => ({
  h1: {
    color: home ? theme.color.brandSecondary.medium : "",
    fontWeight: home ? "900" : "",
    small: {
      color: theme.color.neutral["08"],
      fontWeight: "500",
    },
  },
}));
